function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Collection from './collection';
import Backbone from '@polleverywhere/backbone';
import _ from 'underscore';

var buildRegex = function buildRegex(term) {
  var escapeChars = /[\\^$.*+?()[\]{}|]/g;
  return new RegExp(term.replace(escapeChars, '\\$&'), 'i');
};
/**
 * Collection that can be filtered locally.
 * Supports adding and removing models.
 */


var FilterableCollection = /*#__PURE__*/function (_Collection) {
  _inheritsLoose(FilterableCollection, _Collection);

  function FilterableCollection() {
    return _Collection.apply(this, arguments) || this;
  }

  var _proto = FilterableCollection.prototype;
  /**
   * @param [Model|Array] models Backbone takes one model or an array of models
   * @param [Object] options
   */

  _proto.initialize = function initialize(models, options) {
    if (options == null) {
      options = {};
    }

    if (models instanceof Backbone.Model) {
      models = models.clone();
    } else if (models instanceof Array) {
      models = models.map(function (model) {
        if (model instanceof Backbone.Model) {
          return model.clone();
        } else {
          return model;
        }
      });
    }

    this.original = new Backbone.Collection(models);
    this.listenTo(this, 'add', function (model) {
      return this.original.add(model.clone());
    });
    return this.listenTo(this, 'remove', function (model) {
      return this.original.remove(model.id);
    });
  }
  /*
   * Filter this collections models by term on the attribute
   *
   * @param [String|RegExp] term Term to search the models with. If a string is provided, a case insensitive regex will be constructed with it. Otherwise, the regex will be used directly.
   * @param [Array] attributes The model attributes to search.
   *
   */
  ;

  _proto.filter = function filter(term, attributes) {
    var _this = this;

    if (term instanceof RegExp) {
      this.filterRegex = term;
    } else {
      this.filterRegex = buildRegex(term);
    }

    var results = this.original.filter(function (model) {
      return _.any(attributes, function (attr) {
        return _this.filterRegex.test(model.get(attr));
      });
    });
    var clones = results.map(function (model) {
      return model.clone();
    });
    return this.reset(clones);
  }
  /*
   * Clear the filter on the collection
   *
   */
  ;

  _proto.clearFilter = function clearFilter() {
    delete this.filterRegex;
    var clones = this.original.map(function (model) {
      return model.clone();
    });
    return this.reset(clones);
  };

  return FilterableCollection;
}(Collection);

export { FilterableCollection as default };